// src/pages/AdSection.jsx
import React, { useState, useEffect } from "react";

const AdSection = () => {
  const [adData, setAdData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAdData = async () => {
      const backendURL = process.env.REACT_APP_BACKEND_URL;
      try {
        // Replace with your actual Express endpoint URL for the ad section
        const response = await fetch(`${backendURL}ad/ad`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setAdData(data);
      } catch (error) {
        console.error("Error fetching ad section data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAdData();
  }, []);

  if (loading) {
    return (
      <section className="mt-32 relative bg-cover bg-center h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500"></div>
      </section>
    );
  }

  // Assuming your Firestore document "ad_section" has the fields: image, header, subheader
  return (
    <section
      className="mt-32 relative bg-cover bg-center h-screen"
      style={{ backgroundImage: `url(${adData.image})` }}
    >
      {/* Optional overlay to darken the image */}
      <div className="absolute inset-0 bg-black opacity-50"></div>
      <div className="relative z-10 flex flex-col justify-center items-center h-full text-center text-white px-6">
        <h2 className="text-4xl font-bold mb-4">{adData.header}</h2>
        <p className="mb-6 text-lg">{adData.subheader}</p>
        <a
          href="#"
          className="inline-flex items-center text-white primary-color hover:bg-yellow-700 focus:ring-1 focus:ring-yellow-500 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:focus:ring-primary-900"
        >
          Shop Now
          <svg
            className="ml-2 -mr-1 w-5 h-5"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
              clipRule="evenodd"
            ></path>
          </svg>
        </a>
      </div>
    </section>
  );
};

export default AdSection;
